// This holds the default props for a PropertyExplanationModal to show the
// explanation for the "hasUsbCChargerIncluded" overarching property.
// The UsbCChargerIncluded component passes this as props to the PropertyExplanationModal by default.
const defaultFactory = {
    productTypeId: 'all',
    property: {
        propertyId: '547674',
        hasExplanation: true,
        displayName: '',
    },
};
export default defaultFactory;
//# sourceMappingURL=defaultFactory.js.map